export default "<h1>Welcome to {{domain}}</h1>"